export const formTabHeader = [
  { label: "Lead", value: "lead" },
  { label: "Contact", value: "contact" },
];
export const formTableHeaders = [
  { label: "Full Name", value: "fullName" },
  { label: "Email", value: "email" },
  { label: "Message", value: "message" },
  {
    label: "Status",
    value: "status",
    dataStyle: { textAlign: "center" },
    headerStyle: { textAlign: "center" },
  },
  { label: "Action", value: "action" },
];
export const faqsHeader = [
  {
    label: "Question",
    value: "question",
  },
  {
    label: "Answer",
    value: "answer",
  },

  {
    label: "CreatedAt",
    value: "createdat",
  },
  {
    label: "Actions",
    value: "actions",
  },
];
export const teamHeader = [
  {
    label: "",
    value: "image",
    labelStyle: { textAlign: "center" },
    dataStyle: { textAlign: "center" },
  },
  {
    label: " Name",
    value: "name",
  },
  {
    label: "Designation",
    value: "designation",
  },
  {
    label: "Description",
    value: "description",
  },
  {
    label: "Actions",
    value: "actions",
  },
];
export const event_headers = [
  { label: "Event Name", value: "eventName" },
  { label: "Category", value: "category" },
  {
    label: "Home Page",
    value: "isPinned",
    headerStyle: { textAlign: "center" },
    dataStyle: { textAlign: "center" },
  },
  { label: "Date ", value: "date" },
  { label: "Type", value: "type" },
  { label: "Status", value: "status" },

  { label: "Action", value: "action" },
];
export const eventTypes = [
  {
    label: "All",
    value: "",
  },
  {
    label: "Upcoming",
    value: "upcoming",
  },
  {
    label: "Highlight",
    value: "highlight",
  },
  {
    label: "Live",
    value: "live",
  },
];
export const eventAccess_options = [
  {
    label: "Free",
    value: "free",
  },
  {
    label: "Paid",
    value: "paid",
  },
];
